


































import { Component, Prop, Emit, Vue, Watch } from 'vue-property-decorator';
import CoreIcon from '@/components/CoreIcon.vue'
import FadeTransition from '@/components/transitions/FadeTransition.vue'

@Component({
    components: {
        CoreIcon,
        FadeTransition
    },
})
export default class CoreMobileBottomDrawer extends Vue {
    @Prop({ default: false, type: Boolean }) public isVisible!: boolean;
    @Prop({ default: true, type: Boolean }) public preventTouchScroll!: boolean;

    private oldOverflowValue = '';

    public mounted() {
        this.handleIsVisibleChange();
    }

    @Watch('isVisible')
    public handleIsVisibleChange() {
        if (this.isVisible) {
            this.setBodyScrolling(false);
        } else {
            this.setBodyScrolling(true);
        }
    }

    public get hasFooter() {
        return !!this.$slots['footer'];
    }

    private setBodyScrolling(toggle: boolean) {
        if (!toggle) {
            this.oldOverflowValue = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = this.oldOverflowValue;
        }
    }

    @Emit('close')
    public handleCloseClick() {
        return;
    }

    public handleTouchMove(event) {
        if (this.preventTouchScroll) {
            event.preventDefault();
        }
    }
}
